import { getContext, setContext } from 'svelte';
import { StateManager } from 'utils/StateManager';
const DATA_SET_ATTRIBUTE_NAME = 'navigationattached';
export class ItemsListManagerStateCreator {
    constructor() {
        this._state = { groups: [], activeIndex: 0, totalItems: 0 };
    }
    get state() {
        return this._state;
    }
    addItems(label, items) {
        let itemIndex = this._state.totalItems;
        const itemsWithIndexes = items.map(data => ({
            itemIndex: itemIndex++,
            data
        }));
        this._state.groups.push({ label, items: itemsWithIndexes });
        this._state.totalItems = itemIndex;
    }
}
export class ItemsListManager extends StateManager {
    constructor() {
        super({ activeIndex: 0, groups: [], totalItems: 0 });
        this.updateActiveIndex = (delta) => {
            const currentVal = this._state.activeIndex;
            const currentGroups = this._state.groups;
            const totalItems = currentGroups.reduce((currentTotal, group) => currentTotal + group.items.length, 0);
            const newActiveIndex = (currentVal + delta) % totalItems;
            this.pathState({ activeIndex: newActiveIndex >= 0 ? newActiveIndex : 0 });
        };
        this._onKeyDownNavigation = (event) => {
            if (event.key === "ArrowDown") {
                this.updateActiveIndex(1);
            }
            if (event.key === "ArrowUp") {
                this.updateActiveIndex(-1);
            }
            if (event.key === "Enter") {
                this.selectItem();
            }
        };
    }
    setState(newState) {
        super.setState(newState);
    }
    setInProgress(inProgress) {
        this.pathState({ inProgress });
    }
    addNavigationEventListeners(element) {
        if (!element || element.dataset[DATA_SET_ATTRIBUTE_NAME]) {
            return;
        }
        element.addEventListener('keydown', this._onKeyDownNavigation);
        element.dataset[DATA_SET_ATTRIBUTE_NAME] = 'true';
    }
    removeNavigationEventListeners(element) {
        element.removeEventListener('keydown', this._onKeyDownNavigation);
        delete element.dataset[DATA_SET_ATTRIBUTE_NAME];
    }
    onItemSelected(callback) {
        this._callback = callback;
    }
    selectItem(itemIndex) {
        let itemToSelect = Number.isInteger(itemIndex) ? itemIndex : this._state.activeIndex;
        let item = undefined;
        let itemsSkipped = 0;
        this._state.groups.forEach(group => {
            var _a;
            if (item) {
                return;
            }
            if (itemsSkipped + group.items.length < itemToSelect) {
                itemsSkipped += group.items.length;
                return;
            }
            item = (_a = group.items.find(item => item.itemIndex === itemToSelect)) === null || _a === void 0 ? void 0 : _a.data;
        });
        if (this._callback && item) {
            this._callback.call(null, item);
        }
    }
}
const CONTEXT_KEY = "itemsListManager";
export function setItemsListManager(itemsListManager) {
    setContext(CONTEXT_KEY, itemsListManager);
}
export function getItemsListManager() {
    return getContext(CONTEXT_KEY);
}
export function getItemsListManagerState() {
    const context = getContext(CONTEXT_KEY);
    if (context) {
        return context.state;
    }
    throw new Error("Can't find context with key " + CONTEXT_KEY);
}
